import { siteNav } from '@/mocks/gua88-site';

const feedLinks = [
  { label: '最新进展', href: '#latest' },
  { label: '续集新料', href: '#feed' },
  { label: '事件时间线', href: '#timeline' },
  { label: '热评投票', href: '#talk' },
];

const helpLinks = [
  { label: '常见问题', href: '#faq' },
  { label: '关于本站', href: '#about' },
  { label: '订阅蹲后续', href: '#subscribe' },
  { label: '联系我们', href: '#about' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="font-display text-2xl text-background-50">88</span>
              <span className="font-heading text-lg font-bold text-background-50">吃瓜 · 后续专区</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              聚焦 88 余波未平的最新进展，持续整理续集爆料、当事人回应与事件走向。
              蹲后续、追新料，做理性吃瓜的追更同路人。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#subscribe"
                className="inline-flex items-center whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-primary-900 transition-colors hover:bg-accent-200"
              >
                <i className="ri-notification-3-line mr-1.5"></i>
                订阅蹲后续
              </a>
              <a
                href="mailto:guanzhu@gua88.readdy.site"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-background-100/30 text-lg text-background-100/90 transition-colors hover:border-accent-200 hover:text-accent-200"
                aria-label="邮箱联系"
              >
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">栏目导航</h3>
            <ul className="mt-4 space-y-2.5">
              {feedLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="inline-flex items-center gap-2 text-sm text-background-100/80 transition-colors hover:text-background-50"
                  >
                    <i className="ri-arrow-right-s-line text-accent-300"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">帮助与联系</h3>
            <ul className="mt-4 space-y-2.5">
              {helpLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="inline-flex items-center gap-2 text-sm text-background-100/80 transition-colors hover:text-background-50"
                  >
                    <i className="ri-arrow-right-s-line text-accent-300"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-100/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/70">
            © 2026 88吃瓜后续专区 · 本站内容基于公开信息整理，以官方与当事人说法为准
          </p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-background-100/70">
            {siteNav.map((n) => (
              <a key={n.href} href={n.href} className="transition-colors hover:text-background-50">
                {n.label}
              </a>
            ))}
          </p>
        </div>
      </div>
    </footer>
  );
}